<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div>
            <base-collapsible class="mb-3"
              customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
              <template slot="headerRight">
                <div class="flex flex-col py-2">
                  <h2 class="dark:text-darkblue-100">{{ $t('products.UnitPriceWithoutTax_from_to') }}</h2>
                </div>
              </template>
              <template slot="content">
                <div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                    <el-form-item prop="UnitPriceWithoutTaxMin">
                      <el-input clearable class="w-full" v-model="form.UnitPriceWithoutTaxMin.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                    <el-form-item prop="UnitPriceWithoutTaxMax">
                      <el-input clearable class="w-full" v-model="form.UnitPriceWithoutTaxMax.value" min="0" max="9999999999"
                        type="number" />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible>
          </div>

          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('products.ItemDescription')}}</label>
              <el-form-item prop="ItemDescription">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ItemDescription.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('products.UnitOfMeasure')}}</label>
              <el-form-item prop="UnitOfMeasure">
                <base-el-select class="w-full" :options="tiposUnidadesMedida" v-model="form.UnitOfMeasure.value" clearable filterable/>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('products.ArticleCode')}}</label>
              <el-form-item prop="ArticleCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ArticleCode.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
 
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'invoicesIssuing/4/products',
      isOpen: this.panelOpen,
      form: {
        ItemDescription: { label: i18n.t('products.ItemDescription'), value: '' },
        UnitOfMeasure: { label: i18n.t('products.UnitOfMeasure'), value: '' },
        UnitPriceWithoutTaxMin: { label: i18n.t('products.UnitPriceWithoutTax_min'), value: '' },
        UnitPriceWithoutTaxMax: { label: i18n.t('products.UnitPriceWithoutTax_max'), value: '' },
        ArticleCode: { label: i18n.t('products.ArticleCode'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposUnidadesMedida: function () {
      return this.$store.getters['config/TIPOS_UNIDADES_MEDIDA']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.ItemDescription.value = _temp.ItemDescription !== undefined && _temp.ItemDescription.value !== '' ? _temp.ItemDescription.value : ''
        this.form.UnitOfMeasure.value = _temp.UnitOfMeasure !== undefined && _temp.UnitOfMeasure.value !== '' ? _temp.UnitOfMeasure.value : ''
        this.form.UnitPriceWithoutTaxMin.value = _temp.UnitPriceWithoutTaxMin !== undefined && _temp.UnitPriceWithoutTaxMin.value !== '' ? _temp.UnitPriceWithoutTaxMin.value : ''
        this.form.UnitPriceWithoutTaxMax.value = _temp.UnitPriceWithoutTaxMax !== undefined && _temp.UnitPriceWithoutTaxMax.value !== '' ? _temp.UnitPriceWithoutTaxMax.value : ''
        this.form.ArticleCode.value = _temp.ArticleCode !== undefined && _temp.ArticleCode.value !== '' ? _temp.ArticleCode.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        ItemDescription: { label: i18n.t('products.ItemDescription'), value: '' },
        UnitOfMeasure: { label: i18n.t('products.UnitOfMeasure'), value: '' },
        UnitPriceWithoutTaxMin: { label: i18n.t('products.UnitPriceWithoutTax_min'), value: '' },
        UnitPriceWithoutTaxMax: { label: i18n.t('products.UnitPriceWithoutTax_max'), value: '' },
        ArticleCode: { label: i18n.t('products.ArticleCode'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
